import * as React from "react";
function SvgPadlock(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g fill="none" stroke="currentColor" strokeWidth={2}>
        <rect width={20} height={18} x={6} y={12} rx={2} />
        <path d="M11 12V7a5 5 0 0110 0v5" />
      </g>
      <circle cx={16} cy={21} r={3} fill="currentColor" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgPadlock);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
